module.exports = __webpack_public_path__ + "static/7-b7d6da414b514b2d78ed7ff9e649f32e.jpg";